module.exports = __webpack_public_path__ + "link2.mp3";